import { api } from './queryInterceptors';

import type { AxiosResponse } from 'axios';
import type { Survey } from '@/types/survey';

/**
 * Retrieve a survey from the API.
 *
 * @param surveyId - The id of the survey to retrieve from the API
 * @returns A Promise resolving to the Axios response containing the Survey.
 */
export async function surveyGetQuery(
  surveyId: string,
): Promise<AxiosResponse<Survey>> {
  const requestOptions = {
    method: 'GET',
    url: `/surveys/${surveyId}/`,
    params: {
      expand: "optionSets,steps"
    },
  };
  return api(requestOptions);
}